import React from 'react';
import styles from './TermsOfService.module.css';

const TermsOfService = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>תנאי שימוש – HOMA</h1>
        
        <p className={styles.intro}>
          ברוך הבא לאתר HOMA ("האתר"). השימוש באתר ובשירותים הניתנים בו כפוף לתנאים המפורטים להלן.
          אנא קרא בעיון את תנאי השימוש לפני השימוש באתר.
        </p>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>1. הסכמה לתנאים</h2>
          <p className={styles.sectionContent}>
            השימוש באתר מהווה הסכמה לתנאים אלה ולמדיניות הפרטיות של האתר. אם אינך מסכים, אנא הימנע משימוש באתר.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>2. השימוש באתר</h2>
          <p className={styles.sectionContent}>
            השימוש באתר הוא למטרות קבלת מידע, צפייה במוצרים ובקשת הצעות מחיר בלבד.
          </p>
          <p className={styles.sectionContent}>
            אין להשתמש באתר לשום מטרה בלתי חוקית או שאינה מותרת על פי תנאים אלו.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>3. אחריות</h2>
          <p className={styles.sectionContent}>
            HOMA עושה מאמצים לשמור על עדכניות ודיוק המידע באתר, אך אינה מתחייבת לכך.
          </p>
          <p className={styles.sectionContent}>
            לא תהיה לחברה אחריות לכל נזק, ישיר או עקיף, הנגרם כתוצאה מהשימוש באתר או מהסתמכות על המידע בו.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>4. קישורים לאתרים חיצוניים</h2>
          <p className={styles.sectionContent}>
            האתר עשוי לכלול קישורים לאתרים אחרים. HOMA אינה אחראית לתוכן, למדיניות הפרטיות או לשירותים הניתנים באתרים חיצוניים.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>5. שינוי והפסקת שירות</h2>
          <p className={styles.sectionContent}>
            HOMA שומרת לעצמה את הזכות לעדכן, לשנות או להפסיק את פעילות האתר או חלק ממנה, בכל עת וללא הודעה מוקדמת.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>6. תחום שיפוט</h2>
          <p className={styles.sectionContent}>
            על השימוש באתר יחולו אך ורק דיני מדינת ישראל, וסמכות השיפוט הבלעדית תהיה לבתי המשפט במחוז תל אביב-יפו.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>7. יצירת קשר</h2>
          <p className={styles.sectionContent}>
            לשאלות או הערות, ניתן לפנות אלינו:
          </p>
          <div className={styles.contactInfo}>
          <p>📧 homaisraelwebsite@gmail.com</p>
          <p>📞 052-8643336</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
